import _ from 'lodash';
import { GRANT } from '@/constants/licenseState';

/**
 * 技工（lab）服務對一個 workspace 是否可用（EC-1811）。
 *
 * 單一真相 = 審核已通過 + 有 HIS url 可打 + HIS 服務旗標為 true（`service.his.enable`，由 turbo
 * `POST /workspaces/auto-binding` / `unbinding` 維護）。`service.lab` 下的舊人工技工旗標不再參考：
 * 它可被後台人工翻動、也不會在 HIS 終止時關閉，會讓「HIS 已終止的診所仍能進技工」。
 *
 * MainLayout / LoginPage / LandingPage 三個入口共用此判斷，避免再分岔。
 *
 * @param {object} ws       `GET /workspaces/:id/by-account` 的 workspace（含 `license_state`）
 * @param {object} wsConfig 同回應的 `config`（含 `his_url`、`service.his.enable`）
 * @returns {boolean}
 */
export const isLabAvailable = (ws, wsConfig) =>
  ws?.license_state === GRANT && !_.isEmpty(wsConfig?.his_url) && wsConfig?.service?.his?.enable === true;
